import { createFeatureSelector, createSelector } from '@ngrx/store'

import * as fromOrders from './orders'
import * as fromFacets from './facets'
import * as fromUser from '../../auth/reducers'
import * as fromRoot from '../../reducers'

import { CombinedExpandState } from '../../facets/models/combined-expand-state'

export interface OrdersState {
    orders: fromOrders.State
    facets: fromFacets.State
}

export interface State extends fromRoot.State {
    orders: OrdersState
}

export const reducers = {
    orders: fromOrders.reducer,
    facets: fromFacets.reducer
}

export const getModuleState = createFeatureSelector<OrdersState>('orders')
export const getOrdersState = createSelector(
    getModuleState,
    (state: OrdersState) => state.orders
)
export const getFacetState = createSelector(
    getModuleState,
    (state: OrdersState) => state.facets
)

// Order State Selectors
export const getOrdersEntities = createSelector(
    getOrdersState,
    state => state.lines
)
export const getOrders = createSelector(
  getOrdersState,
  fromOrders.getAll
)
export const getNextPageNumber = createSelector(
  getOrdersState,
  state => state.nextPage
)
export const getIndexedOrders = createSelector(
    getOrdersState,
    fromOrders.getOrdersIndexed
)
export const getOrderNumbers = createSelector(
    getOrdersState,
    fromOrders.getOrderNumbers
)

export const isLoading = createSelector(
    getOrdersState,
    fromOrders.isLoading
)
export const isExpanding = createSelector(
    getOrdersState,
    fromOrders.isExpanding
)
export const getOrderlines = createSelector(
    getOrdersState,
    fromOrders.getLines
)
export const getLastLineId = createSelector(
    getOrdersState,
    fromOrders.getLastLineId
)
export const getStateLineCount = createSelector(
    getOrdersState,
    fromOrders.getLineCount
)
export const canExpand = createSelector(
    getOrdersState,
    fromOrders.canExpand
)

// Facet State Selectors
export const isInitializing = createSelector(
    getFacetState,
    fromFacets.isInitializing
)
export const isLoadingFacets = createSelector(
    getFacetState,
    fromFacets.isLoading
)
export const getUXFacetGroups = createSelector(
    getFacetState,
    fromFacets.getFacetsUX
)
export const getAppliedFacets = createSelector(
    getFacetState,
    fromFacets.getAppliedFacets
)
export const hasGroups = createSelector(
    getFacetState,
    fromFacets.hasGroups
)
export const hasFacets = createSelector(
    getFacetState,
    fromFacets.hasFacets
)
export const hasApplied = createSelector(
    getFacetState,
    fromFacets.hasApplied
)

// Combined Selectors
export const getCombinedExpandState = createSelector(
    fromUser.getCustomerId,
    getLastLineId,
    getAppliedFacets,
    (customerId, lastId, facets) => (new CombinedExpandState(
        customerId,
        lastId,
        facets
    ))
)
export const isInitialized = createSelector(
    hasGroups,
    hasFacets,
    (hasGroups, hasFacets) => hasGroups && hasFacets
)
export const isFacetsReady = createSelector(
    isInitializing,
    isLoadingFacets,
    (initializing, loading) => !(initializing || loading)
)
export const isLinesLoading = createSelector(
    isFacetsReady,
    isLoading,
    (facetsReady, linesLoading) => !facetsReady || linesLoading
)
